import { DataBroker } from './DataBroker';

function RenderShiur(jsonData) {
	const aliyot = [0,1,2,3,4,5];

	return	<div className='Chumash'>
				<center className='shiur-title'><b>שירת האזינו</b></center>
				<p>
				{	aliyot.map(i => 
						jsonData.aliyot[i].psukim.map(p => {
							return	<span><small className="pasuk-number">{p.pasuk}</small>&nbsp;{p.text} </span>
						})
					)
				}
				</p>
			</div>;
}

export async function GetHZ() {
	const jsonData = await DataBroker.getDataJson('cm/53');

	return new Promise((myResolve, myReject) => {
		if (jsonData === null)
			myReject(DataBroker.getError());
		else
			myResolve(RenderShiur(jsonData));
	});
};